"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGINATION_SKELETON = void 0;
const PAGINATION_SKELETON = exports.PAGINATION_SKELETON = 'pagination-skeleton';
